export default __webpack_public_path__ + "static/media/08-energizer-principles.918edfa1.svg";